import React, { useEffect, useState } from "react";
import { Button } from "antd";
import IGGTable from "../../components/CargoCraneCom/IGGRow";
import { post } from "../../../../../services/services";
import { ApiURL } from "../../../../../services/apiConstants";
import SisLoader from "../../../../../widgets/loader";
import { ErrorToast, SuccessToast } from "../../../../../widgets/AppToast";
import AddIGGModal from "../../components/CargoCraneCom/AddIGGModal";

function IGG({ id, onSuccess }) {
  const [loader, set_loader] = useState(false);
  const [FilteredData, setFilteredData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [responeData, setResponeData] = useState({});
  const [errors, set_errors] = useState({});

  const LIST_API = () => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("ship_id", id);
    try {
      post(ApiURL.list_igg_details_com, FORM_DATA).then((res) => {
        if (res?.status === true) {
          setFilteredData(res?.response_data);
        }
      });
    } catch (error) {
      console.error("Error fetching IGG list:", error);
    }
  };

  useEffect(() => {
    LIST_API();
  }, []);

  const ADD_API = (data) => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("igg_name", data?.igg_name);
      FORM_DATA.append("igg_model", data?.igg_model);
      FORM_DATA.append("igg_maker", data?.igg_maker);
      FORM_DATA.append("selected_parameters", JSON.stringify(data?.selectedParams));
      FORM_DATA.append("other_parameters", JSON.stringify(data?.customParams));
      post(ApiURL.add_igg_details_com, FORM_DATA).then((res) => {
        if (res?.status === true) {
          SuccessToast("IGG Details Saved!", "IGG Details Successfully Added!!");
          LIST_API();
          setIsModalOpen(false);
          if (onSuccess) onSuccess();
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
        set_loader(false);
      });
    } catch (error) {
      set_loader(false);
      console.error("Error occurred while adding IGG details:", error);
    }
  };

  const UPDATE_API = (data) => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("id", data?.id);
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("igg_name", data?.igg_name);
      FORM_DATA.append("igg_model", data?.igg_model);
      FORM_DATA.append("igg_maker", data?.igg_maker);
      FORM_DATA.append("selected_parameters", JSON.stringify(data?.selectedParams));
      FORM_DATA.append("other_parameters", JSON.stringify(data?.customParams));
      post(ApiURL.ship_igg_details_com, FORM_DATA).then((res) => {
        if (res?.status === true) {
          SuccessToast("Success", res?.message);
          LIST_API();
          setIsModalOpen(false);
          set_loader(false);
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
          set_loader(false);
        }
      });
    } catch (error) {
      set_loader(false);
      ErrorToast("Error Occurred", "There was an error during registration.");
    }
  };

  const VIEW_API = (data) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", id);
      FORM_DATA.append("id", data?.id);
      FORM_DATA.append("request_type", "view");
      post(ApiURL.ship_igg_details_com, FORM_DATA).then((res) => {
        console.log("Response from VIEW_API:", res?.igg_parameters_data);
        if (res?.status === true) {
          setResponeData(res?.igg_parameters_data);
          setIsModalOpen(true);
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
          set_loader(false);
        }
      });
    } catch (error) {
      console.error("Error while viewing IGG details", error);
    }
  };

  return (
    <>
      <div style={{ position: "relative" }}>
        <h3 style={{ marginTop: "15px", marginBottom: "15px" }}>IGG Information</h3>
        <Button
          type="primary"
          onClick={() => setIsModalOpen(true)}
          style={{ position: "absolute", right: "0px", top: "-10px" }}
        >
          Add IGG
        </Button>
        <AddIGGModal
          visible={isModalOpen}
          onOk={(data) => {
            if (responeData?.id) {
              UPDATE_API({ ...data, id: responeData.id });
            } else {
              ADD_API(data);
            }
          }}
          onCancel={() => {
            setIsModalOpen(false);
            setResponeData({});
            set_errors({});
          }}
          responeData={responeData}
          errors={errors}
        />
        {loader ? (
          <SisLoader />
        ) : (
          <>
            {FilteredData?.length > 0 ? (
              <IGGTable data={FilteredData} onEdit={(row) => VIEW_API(row)} />
            ) : (
              "No data available"
            )}
          </>
        )}
      </div>
    </>
  );
}

export default IGG;
